export default "__VITE_ASSET__3f8f3f66__"